<template>
  <!-- 用户管理-赠送优惠券 -->
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="赠送优惠券"
      width="400px"
      @close="closeDialog"
    >
      <el-form label-width="100px" size="small" :rules="replyRules">
        <el-form-item prop="coupon_id" label="优惠券类型">
          <el-select v-model="coupon_id" placeholder="请选择优惠券">
            <el-option
              v-for="item in dataList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="submit" :loading="buttonLoading"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'

export default {
  props: {
    visible: {//展示标志
      type: Boolean,
      default: false
    },
    value: {//数据
      type: Object,
      default: undefined
    },
    type: {//类型
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      lock: false,//加锁
      dataList: undefined,
      coupon_id: undefined,//优惠券的id
      replyRules: {//回复弹窗规则验证
      }
    }
  },
  computed: {
    ...mapState({
    }),
    dialogVisible: {
      get() {
        return this.visible
      },
      set() {
      }
    },
    fromInfo: {
      get() {
        return this.value
      },
      set() {
      }
    },
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.getData()
      } else {
        this.coupon_id = undefined
      }
    },
  },
  created() {
  },
  methods: {
    getData() {
      //拿取所有的优惠券信息
      getApiData('coupon_list').then(res => {
        this.dataList = res
      }).finally(() => {
      })
    },
    submit() {
      //保存任务
      //表单验证后发起请求
      if (!this.coupon_id) {
        this.$message.success("请先选择优惠券")
        return
      }
      this.buttonLoading = true
      let params = {
        user_id: this.fromInfo.id,
        id: this.coupon_id
      }
      postApiData('coupons_provide', params).then(res => {
        if (res.code) {
          this.$message.success(res.message)
          this.$emit('refresh')
          this.closeDialog()
        } else {
          this.$message.error(res.message)
        }
      }).finally(() => {
        this.buttonLoading = false
      })
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    }
  }

}
</script>
<style lang="less" scoped>
</style>